import MeetingMW from "@/middlewares/Meeting";
import MeetingResolutionMW from "@/middlewares/MeetingResolution";
import ResolutionVoteMW from "@/middlewares/ResolutionVote";

import MeetingORM from "@/store/orm-axios/models/Meeting";
import MeetingResolutionORM from "@/store/orm-axios/models/MeetingResolution";
import ResolutionVoteORM from "@/store/orm-axios/models/ResolutionVote";
import MeetingCorrespondenceVoteORM from "@/store/orm-axios/models/MeetingCorrespondenceVote";

import { meetingMinutesNames } from "@/constants/meeting.js";

export default {
  data() {
    return {
      voteEvents: [],
    };
  },
  methods: {
    /** NOTE: main functions */
    recalculateCurrentIgnoredCorrespondenceVote() {
      this.$swal(this.alertQuestion()).then(res => {
        if (res.value) {
          this.doRecalculateCurrentIgnoredCorrespondenceVote();
        }
      });
    },
    async doRecalculateCurrentIgnoredCorrespondenceVote() {
      const keepResolutionVoteDate = true;
      this.$store.state.showLoaderOverlay = true;

      try {
        await this.resetIgnoredCorrespondenceForCurrentResolution();

        this.voteEvents = [];
        await this.doOneResolutionProcess(this.currentResolution, keepResolutionVoteDate);

        await this.updateMeetingMinutesVotes(this.voteEvents);
        this.forceRerenderResolution();
      } catch (err) {
        console.error(err);
        this.$swal(this.alertError());
      }

      this.$store.state.showLoaderOverlay = false;
    },
    recalculateAllIgnoredCorrespondenceVotes() {
      // NOTE: TASK DEV-5359 keep resolutionVote date
      const keepResolutionVoteDate = true;
      this.$swal(this.alertQuestion()).then(res => {
        if (res.value) {
          this.doRecalculateAllIgnoredCorrespondenceVotes(keepResolutionVoteDate);
        }
      });
    },
    async doRecalculateAllIgnoredCorrespondenceVotes(keepResolutionVoteDate = false) {
      this.$store.state.showLoaderOverlay = true;

      try {
        // NOTE: Get all resolutionVotes with ignoredCorrespondence for this meeting
        // (because, we fetch only the resolutionVotes for currentResolution displayed, and clear store after moving to other Resolution)
        await this.getResolutionVotesWithIgnoredCorrespondence(this.meeting.id);
        var allResolutionsWithIgnoredVotes = MeetingResolutionORM.query()
          .whereHas("resolution_votes", query => {
            query.where(rv => !!rv.ignored_correspondence);
          })
          .where(mr => {
            return this.ignoredMeetingResolutionsCorrespondenceVotesCondition(mr);
          })
          .get();

        await this.resetIgnoredCorrespondenceForAllResolutions();

        // NOTE: Get all resolutionVotes because we fetch only the resolutionVotes for currentResolution displayed
        await this.getResolutionVotesByMeeting(this.meeting.id);

        this.voteEvents = [];
        for (var resolution of allResolutionsWithIgnoredVotes) {
          await this.doOneResolutionProcess(resolution, keepResolutionVoteDate);
        }

        await this.updateMeetingMinutesVotes(this.voteEvents);
        this.forceRerenderResolution();
      } catch (err) {
        console.error(err);
        this.$swal(this.alertError());
      }

      this.$store.state.showLoaderOverlay = false;
    },
    voteForAllIfByCorrespondance() {
      this.$swal(this.alertQuestion()).then(res => {
        if (res.value) {
          this.doVoteForAllIfByCorrespondance();
        }
      });
    },
    async doVoteForAllIfByCorrespondance() {
      this.$store.state.showLoaderOverlay = true;

      try {
        // NOTE: reset minutes and create new meeting-start event
        await MeetingORM.update({
          where: this.meeting.id,
          data(item) {
            item.minutes = [];
          },
        });

        try {
          await this.setCorrespondenceEvents();
          await this.setGeneralDetailsAndMeetingStartEvents();
          await this.setFreezedMeetingDetailsInMeeting();
        } catch {
          this.$swal(this.alertError());
          throw new Error(err);
        }

        this.voteEvents = [];
        for (var resolution of this.allMeetingResolutions) {
          if (resolution.children_resolutions.length > 0) {
            for (var childResolution of resolution.children_resolutions) {
              await this.doOneResolutionProcess(childResolution);
            }
          } else if (!resolution.parent_resolution_id) {
            await this.doOneResolutionProcess(resolution);
          }
        }

        await this.updateMeetingMinutesVotes(this.voteEvents);
        this.forceRerenderResolution();
      } catch (err) {
        console.error(err);
        this.$swal(this.alertError());
      }

      this.$store.state.showLoaderOverlay = false;
    },

    // ...
    ignoredMeetingResolutionsCorrespondenceVotesCondition(meetingResolution) {
      return (
        meetingResolution.meeting_id == this.$route.params.id &&
        !!meetingResolution.status &&
        meetingResolution.status != this.meetingResolutionStatuses.not_resolved &&
        meetingResolution.status != this.meetingResolutionStatuses.sans_vote
      );
    },
    async resetIgnoredCorrespondenceForAllResolutions() {
      var ignoredCorrespondenceVotes = ResolutionVoteORM.query()
        .whereHas("meeting_resolution", query => {
          query.where(mr => {
            return this.ignoredMeetingResolutionsCorrespondenceVotesCondition(mr);
          });
        })
        .where(rv => !!rv.ignored_correspondence)
        .get();

      this.resetIgnoredCorrespondenceInStore(ignoredCorrespondenceVotes);
      await this.resetIgnoredCorrespondenceInDB(ignoredCorrespondenceVotes);
    },
    async resetIgnoredCorrespondenceForCurrentResolution() {
      var ignoredCorrespondenceVotes = ResolutionVoteORM.query()
        .whereHas("meeting_resolution", query => {
          query.where("id", this.currentResolution.id);
        })
        .where(rv => !!rv.ignored_correspondence)
        .get();

      this.resetIgnoredCorrespondenceInStore(ignoredCorrespondenceVotes);
      await this.resetIgnoredCorrespondenceInDB(ignoredCorrespondenceVotes);
    },
    resetIgnoredCorrespondenceInStore(ignoredCorrespondenceVotes) {
      for (const vote of ignoredCorrespondenceVotes) {
        ResolutionVoteORM.update({
          where: vote.id,
          data: {
            ignored_correspondence: 0,
          },
        });
      }
    },
    async resetIgnoredCorrespondenceInDB(ignoredCorrespondenceVotes) {
      if (ignoredCorrespondenceVotes.length == 0) {
        return;
      }
      await ResolutionVoteMW.RESET_IGNORED_CORRESPONDENCE(
        ignoredCorrespondenceVotes,
        this.$route.params.id
      ).catch(err => {
        console.error(err);
        this.$swal(this.alertError());
      });
    },

    async doOneResolutionProcess(resolution, keepResolutionVoteDate = false) {
      // reset resolution status and revote_majority_id then ..
      await MeetingResolutionORM.update({
        where: resolution.id,
        data(item) {
          item.status = null;
          item.revote_majority_id = null;
        },
      }).then(async mr => {
        let meetingResolution = this.allMeetingResolutions.find(mr2 => {
          return mr2.id == mr.id;
        });

        await this.oneResolutionProcess(meetingResolution, keepResolutionVoteDate);
      });
    },
    async oneResolutionProcess(resolution, keepResolutionVoteDate = false) {
      let majority = this.getResolutionMajority(resolution);

      // NOTE: Update resolution votes with proposed votes before getting the status, because it needs to be calculated based on the votes
      await this.oneResolutionUpdateResolutionVote(resolution, majority, null, false);

      let status = this.getResolutionStatus(resolution, majority);
      let votes = this.getCurrentResolutionVotes(resolution, status);

      if (this.isRevoteCase(resolution, majority, status)) {
        // set resolution revote_majority_id then ..
        await MeetingResolutionORM.update({
          where: resolution.id,
          data(item) {
            item.revote_majority_id = majority.majority_conditions.revoteMajority;
          },
        }).then(async mr => {
          let meetingResolution = this.$_.find(this.allMeetingResolutions, mr2 => {
            return mr2.id == mr.id;
          });
          let updatedVotes = await this.oneResolutionUpdateResolutionVote(
            meetingResolution,
            majority,
            status
          );
          votes = updatedVotes;
          this.createVoteEvent(meetingResolution, majority, votes, true, keepResolutionVoteDate);
          await this.oneResolutionProcess(meetingResolution);
        });
      } else {
        let updatedVotes = await this.oneResolutionUpdateResolutionVote(
          resolution,
          majority,
          status
        );
        votes = updatedVotes;
        this.createVoteEvent(resolution, majority, votes, false, keepResolutionVoteDate);
        await this.updateMeetingResolutionStatus(resolution, status);
      }
    },

    getResolutionMajority(resolution) {
      if (resolution.revote_majority_id) {
        return this.findMajorityData(resolution.revote_majority_id);
      } else {
        return this.findMajorityData(resolution.majority_id);
      }
    },
    // ???: kind of duplicate code, like in VotingIndicators.vue (2021.10.20)
    getResolutionStatus(resolution, majority) {
      if (majority.majority_conditions) {
        var result = false;
        var passed = [];

        majority.majority_conditions.rules.forEach(rule => {
          let check = this.ITERATE_RULES(resolution, rule);
          passed.push(check);
        });

        if (majority.majority_conditions.rulesOperator == this.rulesOptions.rulesOperators.et) {
          result = passed.every(item => !!item.passed);
        } else if (
          majority.majority_conditions.rulesOperator == this.rulesOptions.rulesOperators.ou
        ) {
          result = passed.some(item => !!item.passed);
        }

        const hasLackOfMajority = this.checkIfHasLackOfMajority(passed);

        if (!result && hasLackOfMajority) {
          return this.meetingResolutionStatuses.rejected_lack_of_majority;
        } else {
          return result
            ? this.meetingResolutionStatuses.accepted
            : this.meetingResolutionStatuses.rejected;
        }
      } else {
        return this.meetingResolutionStatuses.sans_vote;
      }
    },
    checkIfHasLackOfMajority(passed) {
      return !!this.$_.some(passed, item => {
        return item.lack_of_majority;
      });
    },

    getCurrentResolutionVotes(resolution, status) {
      let currentResolution = MeetingResolutionORM.query()
        .where("id", resolution.id)
        .with("resolution_votes", query => {
          query.with("mandate");
        })
        .first();
      if (
        status != this.meetingResolutionStatuses.not_resolved &&
        status != this.meetingResolutionStatuses.sans_vote
      ) {
        return this.getResolutionVotesForMinutes(currentResolution);
      } else {
        return null;
      }
    },

    isRevoteCase(resolution, majority, status) {
      return (
        (status == this.meetingResolutionStatuses.rejected ||
          status == this.meetingResolutionStatuses.rejected_lack_of_majority) &&
        this.getRevoteRulesResult(resolution, majority.majority_conditions) &&
        !resolution.revote_majority_id
      );
    },

    createVoteEvent(resolution, majority, votes, isRevote = false, keepResolutionVoteDate = false) {
      // NOTE: Decided after the changes here DEV-4771, that we will not change the resolution-vote date when vote to recalculate correspondence votes
      let resolutionVote = null;
      if (keepResolutionVoteDate) {
        resolutionVote = this.ifResolutionWasVotedBeforeDeleteFromMinutes(resolution.id);
      }
      var voteEvent = this.getResolutionVoteEvent({
        resolution_id: resolution.id,
        majority_id: majority.id,
        votes,
        date: resolutionVote ? resolutionVote.date : null,
      });

      if (isRevote) {
        voteEvent.revote_majority_id = majority.majority_conditions.revoteMajority;
      }
      this.voteEvents.push(voteEvent);
    },

    async updateMeetingResolutionStatus(resolution, status) {
      try {
        await MeetingResolutionORM.update({
          where: resolution.id,
          data(item) {
            item.status = status;
          },
        }).then(async mr => {
          await MeetingResolutionMW.PUT(mr); // + resolution revote_majority_id gets set before
        });
      } catch (err) {
        console.error(err);
        this.$swal(this.alertError());
      }
    },
    async updateMeetingMinutesVotes(events) {
      try {
        // NOTE: filter resolution vote events that need to be changed
        let minutes = this.meeting.minutes.filter(minuteEvent => {
          return (
            minuteEvent.event !== meetingMinutesNames.resolution_vote ||
            (minuteEvent.event == meetingMinutesNames.resolution_vote &&
              !events.find(e => e.resolution_id == minuteEvent.resolution_id))
          );
        });
        events.forEach(event => {
          minutes.push(event);
        });

        await MeetingORM.update({
          where: this.meeting.id,
          data(item) {
            item.minutes = minutes;
          },
        }).then(async m => {
          await MeetingMW.PUT(m);
        });
      } catch (err) {
        console.error(err);
        this.$swal(this.alertError());
      }
    },
    async updateMeetingVotesNeedRecalculations() {
      await MeetingORM.update({
        where: this.$route.params.id,
        data(item) {
          item.votes_need_recalculations = 1;
        },
      })
        .then(async m => {
          await MeetingMW.PUT(m);
        })
        .catch(err => {
          console.error(err);
          this.$swal(this.alertError());
        });
    },

    getRevoteRulesResult(resolution, majorityConditions) {
      if (majorityConditions) {
        if (!majorityConditions.revote) return false;
        var passed = [];
        majorityConditions.revoteRules.forEach(rule => {
          let check = this.ITERATE_RULES(resolution, rule);

          passed.push(check);
        });

        // check et/ou ..
        // et
        if (majorityConditions.revoteRulesOperator == this.rulesOptions.rulesOperators.et) {
          return passed.every(item => item.passed);
        }
        // ou
        else if (majorityConditions.revoteRulesOperator == this.rulesOptions.rulesOperators.ou) {
          return passed.some(item => item.passed);
        }
      }
      return false;
    },

    // ???: duplicate code, like in VotingIndicators.vue (2021.10.15)
    ITERATE_RULES(resolution, rule) {
      let result = {
        passed: false,
        lack_of_majority: false,
      };
      var r = rule;

      let values = {
        presentTantiemes: this.getUsedMandatesTantiemesByVotingCategory(
          this.presentMandates,
          resolution.voting_category_id
        ),
        representedTantiemes: this.getUsedMandatesTantiemesByVotingCategory(
          this.representedMandates,
          resolution.voting_category_id
        ),
        videoTantiemes: this.videoTantiemes,
        representedVideoTantiemes: this.representedVideoTantiemes,
        correspondenceTantiemes: this.correspondenceTantiemes,
        absentButVotedInPersonTantiemes: this.absentButVotedInPersonTantiemes,
        absentButVotedTantiemes: this.absentButVotedTantiemes,
        presentMandates: this.presentMandates,
        representedMandates: this.representedMandates,
        videoMandates: this.videoMandates,
        representedVideoMandates: this.representedVideoMandates,
        correspondenceMandates: this.correspondenceMandates,
        absentMandatesButVotedInPerson: this.absentMandatesButVotedInPerson,
        absentMandatesButVoted: this.absentMandatesButVoted,
      };

      if (r.majorityType == this.rulesOptions.majorityType.totalTantiemes) {
        if (r.forOrAgainst == this.rulesOptions.forOrAgainst.for) {
          return this.CHECK_RULE(resolution, "tantiemes", "for", r, values);
        } else if (r.forOrAgainst == this.rulesOptions.forOrAgainst.against) {
          return this.CHECK_RULE(resolution, "tantiemes", "against", r, values);
        }
      } else if (r.majorityType == this.rulesOptions.majorityType.totalVotes) {
        if (r.cumulMandates == this.rulesOptions.cumulMandates.withCumulMandates) {
          if (r.forOrAgainst == this.rulesOptions.forOrAgainst.for) {
            return this.CHECK_RULE(resolution, "votes", "for", r, values);
          } else if (r.forOrAgainst == this.rulesOptions.forOrAgainst.against) {
            return this.CHECK_RULE(resolution, "votes", "against", r, values);
          }
        }
        // TODO: w/o cumul mandates
        else if (r.cumulMandates == this.rulesOptions.cumulMandates.withoutCumulMandates) {
          if (r.forOrAgainst == this.rulesOptions.forOrAgainst.for) {
            return this.CHECK_RULE(resolution, "votes-no-cumul-mandates", "for", r, values);
          } else if (r.forOrAgainst == this.rulesOptions.forOrAgainst.against) {
            return this.CHECK_RULE(resolution, "votes-no-cumul-mandates", "against", r, valuess);
          }
        }
      }

      return result;
    },
    async oneResolutionUpdateResolutionVote(meetingResolution, majority, status, updateApi = true) {
      let resolutionVotes = ResolutionVoteORM.getters("getResolutionVotesByResolution")(
        meetingResolution.id
      );
      if (resolutionVotes.length == 0) {
        resolutionVotes = await this.getResolutionVotesIfNecessary(meetingResolution.id);
      }
      let meetingCorrespondenceVotes = MeetingCorrespondenceVoteORM.query()
        .where("meeting_id", meetingResolution.meeting_id)
        .get();

      resolutionVotes.forEach(resolutionVote => {
        let meetingCorrespondenceVote = this.$_.find(meetingCorrespondenceVotes, item => {
          return item.mandate_id == resolutionVote.mandate_id;
        });
        if (!meetingCorrespondenceVote) {
          return;
        }

        let proposedVotes = meetingCorrespondenceVote.proposed_votes;
        if (proposedVotes && proposedVotes.length > 0) {
          let proposedVote = this.$_.find(proposedVotes, item => {
            return (
              item.meeting_resolution_id == meetingResolution.id && item.majority_id == majority.id
            );
          });
          if (proposedVote) {
            ResolutionVoteORM.update({
              where: resolutionVote.id,
              data: {
                vote: proposedVote.vote,
              },
            });
          }
        }
      });
      let updatedResolutionVotes = ResolutionVoteORM.getters("getResolutionVotesByResolution")(
        meetingResolution.id
      );
      let votes = [];
      if (updateApi) {
        votes = this.getCurrentResolutionVotes(meetingResolution, status);
      } else {
        votes = updatedResolutionVotes;
      }

      return votes;
    },
    async getResolutionVotesIfNecessary(meetingResolutionId) {
      let result = [];
      await ResolutionVoteMW.FETCH(meetingResolutionId).then(() => {
        result = ResolutionVoteORM.getters("getResolutionVotesByResolution")(meetingResolutionId);
      });
      return result;
    },
    async getResolutionVotesWithIgnoredCorrespondence(meetingId) {
      await ResolutionVoteMW.GET_IGNORED_CORRESPONDENCE(meetingId).catch(err => {
        console.error(err);
        this.$swal(this.alertError());
      });
    },
    async getResolutionVotesByMeeting(meetingId) {
      await ResolutionVoteMW.GET_BY_MEETING(meetingId).catch(err => {
        console.error(err);
        this.$swal(this.alertError());
      });
    },
  },
};
